module.exports = __webpack_public_path__ + "static/media/ico_refresh.f6322557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ico_refresh.png
// module id = 60
// module chunks = 0